import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

import img1 from "../../assets/hero1.png"; 
import img2 from "../../assets/hero2.png";
import img3 from "../../assets/hero3.png";
import img4 from "../../assets/hero4.png";
import img5 from "../../assets/hero1.png";
import img6 from "../../assets/hero2.png";
import img7 from "../../assets/hero4.png";
import img8 from "../../assets/hero3.png";

const imageSets = [
  { tall: img1, top: img2, bottom: img3, full: img4 },
  { tall: img5, top: img6, bottom: img7, full: img8 },
];

const Landing = () => {

  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  return (
    <div className="bg-white px-6 md:px-12 py-12">
      {/* Hero Section */}
      <main className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
        {/* Left Text Section */}
        <div className="text-center md:text-left" data-aos="fade-right">
          <h1 className="text-3xl md:text-4xl font-extrabold text-gray-900 leading-snug">
            WELCOME TO <br className="hidden md:block" /> BUTTERFLY GROUPS
          </h1>
          <p className="mt-6 text-gray-700 text-base md:text-lg">
            From Consulting to Wellness, from Homes to Healing,{" "}
            <span className="font-semibold">Butterfly Groups</span> is where
            transformation takes flight.
          </p>
        </div>

        {/* Right Image Grid */}
        <div className="relative h-[350px] sm:h-[400px] w-full max-w-sm md:w-[420px] mx-auto overflow-hidden rounded-lg">
          {/* Scrolling Container */}
          <div className="animate-scrollUp hover:[animation-play-state:paused]">
            {[...imageSets, ...imageSets].map((set, index) => (
              <div key={index} className="grid grid-cols-2 gap-3 mb-3">
                {/* Tall left image */}
                <img
                  src={set.tall}
                  alt={`Tall ${index}`}
                  className="rounded-lg shadow row-span-2 object-cover w-full h-40 sm:h-52 md:h-full"
                />

                {/* Top-right */}
                <img
                  src={set.top}
                  alt={`Top ${index}`}
                  className="rounded-lg shadow object-cover w-full h-28 sm:h-36 md:h-[160px]"
                />

                {/* Bottom-right */}
                <img
                  src={set.bottom}
                  alt={`Bottom ${index}`}
                  className="rounded-lg shadow object-cover w-full h-28 sm:h-36 md:h-[160px]"
                />

                {/* Bottom full-width */}
                <img
                  src={set.full}
                  alt={`Full ${index}`}
                  className="rounded-lg shadow object-cover w-full h-28 sm:h-32 md:h-[140px] col-span-2"
                />
              </div>
            ))}
          </div>
        </div>
      </main>
    </div>
  );
};

export default Landing;
